import Vue from "vue";
import Vuex from "vuex";
import SessionStore from "@/store/sessionStore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    SessionStore,
  },
});
